/* eslint-disable react/jsx-fragments */
import React from "react";
import PropTypes from "prop-types";
import Modal from "reactstrap/lib/Modal";
import ModalBody from "reactstrap/lib/ModalBody";
import ModalFooter from "reactstrap/lib/ModalFooter";

import {
  gatherClasses,
  gatherConditionalProps,
  isFunction
} from "../../lib/utils";
import Button from "../button/button";
import { handleIERenderingIssues } from "../../lib/modalUtils";

class InformationModal extends React.Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
  }

  onModalOpen = () => {
    const { onOpened } = this.props;

    handleIERenderingIssues(this.ref.current);

    if (isFunction(onOpened)) {
      onOpened();
    }
  };

  render() {
    const {
      body,
      bodyClassName,
      toggle,
      message,
      secondaryMessage,
      okButtonText,
      dataTestId,
      closeOnEscape
    } = this.props;

    return (
      <Modal
        data-testid={dataTestId}
        innerRef={this.ref}
        centered
        className={gatherClasses(this.props, "information-modal")}
        keyboard={closeOnEscape}
        {...gatherConditionalProps(
          this.props,
          "isOpen",
          "size",
          "autoFocus",
          "backdrop",
          "toggle",
          "onClosed"
        )}
        onOpened={this.onModalOpen}
      >
        <ModalBody className={bodyClassName}>
          {isFunction(body) ? (
            body()
          ) : (
            <React.Fragment>
              <div aria-label={message}>{message}</div>
              {secondaryMessage && (
                <div>
                  <br />
                  <div>{secondaryMessage}</div>
                </div>
              )}
            </React.Fragment>
          )}
        </ModalBody>

        <ModalFooter>
          <Button label={okButtonText} onClick={toggle} type="primary" />
        </ModalFooter>
      </Modal>
    );
  }
}

InformationModal.propTypes = {
  isOpen: PropTypes.bool,
  body: PropTypes.func,
  closeOnEscape: PropTypes.bool,
  message: PropTypes.string,
  secondaryMessage: PropTypes.string,
  okButtonText: PropTypes.string,
  className: PropTypes.string,
  bodyClassName: PropTypes.string,
  size: PropTypes.oneOf(["lg", "md", "sm"]),
  toggle: PropTypes.func.isRequired,
  onOpened: PropTypes.func,
  onClosed: PropTypes.func,
  dataTestId: PropTypes.string,
  backdrop: PropTypes.string
};

InformationModal.defaultProps = {
  isOpen: false,
  secondaryMessage: "",
  okButtonText: "OK",
  className: "",
  size: "sm",
  // eslint-disable-next-line react/default-props-match-prop-types
  toggle: () => {},
  bodyClassName: null,
  closeOnEscape: false,
  backdrop: "static",
  dataTestId: "orion-information-modal"
};

InformationModal.displayName = "OrionInformationModal";

export default InformationModal;
